import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Chatbot } from "./components/chat/Chatbot";
import RegionRedirect from "./components/RegionRedirect";
import { AppRoutes } from "./components/AppRoutes";

const queryClient = new QueryClient();

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col min-h-screen">
        <RegionRedirect />
        <div className="flex-grow">
          <Toaster />
          <Sonner />
          <TooltipProvider>
            <AppRoutes />
          </TooltipProvider>
          <Chatbot />
        </div>
      </div>
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;